import { useGroomMode } from "../../context/GroomModeContext";
import GroomNote from "./GroomNote";
import { FAQS } from "../../constants/siteContent";

export default function FAQSection() {
  const groomMode = useGroomMode();

  return (
    <section id="faq" className="faq" aria-labelledby="faq-heading">
      <div className="section-inner section-inner--narrow">
        <h2 id="faq-heading" className="section-heading">
          {groomMode ? "Matt's Honest Q&A" : "Questions & Answers"}
        </h2>
        <p className="section-lead">
          {groomMode
            ? "The real answers Kim wouldn't let me put on the website."
            : "Everything you need to know — so you can focus on having a great time."}
        </p>

        <div className="faq-list">
          {FAQS.map((faq) => (
            <details key={faq.question} className="faq-item">
              <summary className="faq-question">{faq.question}</summary>
              <div className="faq-answer">
                <p>{faq.answer}</p>
                {groomMode && <GroomNote note={faq.groom} />}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
